<ng-container *ngIf="form" [formGroup]="form" (dragover)="onImportDragOver($event)" (dragleave)="onImportDragLeave($event)" (drop)="onImportDrop($event)">
  <div class="topbar">
    <h4 class="topbar-title">
      Sender IDs<span class="icon-help-1 ml-15" tooltip="Select from Content templates or type a Sender" tooltipPlacement="top"></span>
    </h4>
    <div class="right-icons">
      <a tooltip="Select a Content template" tooltipPlacement="top" (click)="openContentTemplatesModal()"><span class="far fa-bookmark"></span></a>
      <a tooltip="Import Content templates from a file" tooltipPlacement="top" (click)="onClickImportFromFile()"><span class="icon-import"></span></a>
    </div>
  </div>
  <div class="sender-input-container mb-20 position-relative">
    <input tabIndex="1" #senderInput placeholder="Type sender names" class="form-control" [(ngModel)]="senderModel" formControlName="sender"
      (keyup.enter)="addSender()" (keydown.Tab)="onTabPressOnSenderInput()" />
    <a *ngIf="senderModel.length > 0" class="icon-action close" (click)="clearSenderField()"><span class="icon-close"></span></a>
    <button *ngIf="senderModel.length > 0" class="icon-action add" (click)="addSender()" [disabled]="form.controls.sender.invalid"><span
        class="icon-add"></span></button>
    <input-errors [control]="form.controls.sender" [service]="validationService"></input-errors>

    <div *ngIf="showAutoCompleteContentTemplates()">
      <div class="autocomplete-lists">
        <div class="pills-holder">
          <span class="title">Custom</span>
          <div class="pills-btn selected" *ngFor="let sender of senders">
            <span class="text">{{ inputListText(sender) }}</span>
            <span class="icon" (click)="removeSender(sender)">
              <span class="icon-close"></span>
            </span>
          </div>
          <div class="pills-btn">
            <span class="text">{{senderModel}}</span>
            <span class="icon" (click)="addSender()">
              <span class="icon-add"></span>
            </span>
          </div>
        </div>
        <div class="pills-holder">
          <span class="title">Select from templates</span>
          <div class="pills-btn" *ngFor="let smsTemplate of autoCompleteContentTemplates" (click)="onSelectFromAutoComplete(smsTemplate)"
            [ngClass]="{'selected':smsTemplate.selected }">
            <span class="text">{{ smsTemplate.name }} ({{ smsTemplate.smsTemplateTextDtos.length }})</span>
            <span class="icon">
              <span [ngClass]="smsTemplate.selected ? 'icon-close': 'icon-add'"></span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <ul [hidden]="!senders.length" class="input-list-items input-list-items-inline">
      <li *ngFor="let sender of senders">
        <span (click)="editSender(sender)">{{ inputListText(sender) }}</span>
        <button (click)="removeSender(sender)" class="input-list-remove btn btn-sm" type="button">
          <i class="text-danger fa fa-times" title="Remove"></i>
        </button>
      </li>
    </ul>
  </div>

  <h4 class="topbar-title mb-10">
    Text
    <span class="icon-help-1 ml-15" [tooltip]="'Enter your text with Test ID Text here'" tooltipPlacement="top"></span>
    <span *ngIf="!textModel.value.length && selectedCount" class="counter">{{selectedCount}}</span>
  </h4>
  <div class="mb-10">
    <div class="text-template-wrapper">
      <app-text-template (changeText)="onChangeText($event)" (editorFocusChange)="textEditorFocused = $event"
        (markerClick)="onClickTelqIdMarker()"></app-text-template>
      <a class="add-icon" [hidden]="!(textModel.value.length > 0 && textLength <= MAX_TEXT_LEN)" (click)="onClickAddContentTemplate()"><span
          class="icon-add"></span></a>
      <div class="bottom-panel d-flex">
        <div *ngIf="textLength" class="text-length-counter item" [ngClass]="textLength > MAX_TEXT_LEN ? 'max' : ''">{{ textLength }}</div>
        <div *ngIf="dataCoding" class="item" [ngClass]="dataCodingLoading ? 'loading' : ''">{{ dataCoding.name }}</div>
      </div>
      <!-- The below button has not been implemented in current UI hence. TP-5332 exists for this ... -->
      <!-- <a class="template-icon"><span class="icon-templates"></span></a> -->
    </div>
    <div *ngIf="testIdPlacementTip" class="test-id-placement-tip d-flex align-items-center mt-10">
      <div class="test-id-placement-tip-icon d-flex justify-content-center align-items-center">
        <i class="icon-info-1"></i>
      </div>
      <div class="test-id-placement-tip-text flex-grow-1">
        <b>Tip:</b> to better imitate real traffic and improve detection, put the ID
        {{ testIdPlacementTip === 'code-slot' ? 'at the end, where the code goes' : 'in place of the code' }} instead.
        <a class="test-id-placement-tip-action" role="button" (click)="moveTestIdToCode()">Do it for me</a>
      </div>
    </div>
  </div>

  <div class="tag-wrapper">
    <ng-container *ngFor="let template of contentTemplates">
      <ng-container *ngFor="let text of template.smsTemplateTextDtos">
        <div *ngIf="text.selected" class="mb-10 template-snippet" (click)="onClickTemplateText($event, template, text)">
          <div class="template-snippet-sender">
            <div class="text">
              {{ template.name | truncate }}
              <div class="additional-texts" *ngIf="template.smsTemplateTextDtos.length > 1"
                (click)="openModalForAdditionalTexts(template);$event.stopPropagation();">
                <span tooltip="See all templates for this sender ID" tooltipPlacement="top" class="icon-actions-hor"></span>
              </div>
            </div>
            <div class="buttons">
              <span class="icon-edit rounded-icon" tooltip="Edit"></span>
              <span (click)="removeTextFromContentTemplate(template, text)" class="icon-close rounded-icon"></span>
            </div>
          </div>
          <div class="template-snippet-text text-break">
            <span [innerHtml]="getHtmlContentForText(text)"></span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

<ng-template #openModalForAdditionalTextsTpl let-dialogRefSender="dialogRef">
  <div class="modal-header">
    <div class="modal-title">
      <h3>Content templates</h3>
      <button type="button" class="btn-close" (click)="dialogRefSender.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="template-form mb-20">
      <br>
      <div class="input-holder">
        <input type="search" class="form-control" #searchForAdditionalText />
        <span class="icon-search"></span>
      </div>
    </div>
    <div class="favoutite-list d-flex">
      <div class="left-col">
        <b>Sender</b>
      </div>
      <div class="right-col">
        <b>Texts</b>
      </div>
    </div>
    <br>
    <div class="favoutite-list d-flex">
      <div class="left-col">
        <div class="chips selected">
          <span class="text">{{selectedContentForAdditionalTexts.name}}</span>
        </div>
      </div>
      <div class="right-col">
        <div class="chips" *ngFor="let text of selectedContentForAdditionalTexts.smsTemplateTextDtos | filterText: searchForAdditionalText.value"
          [ngClass]="{'selected': text.selected}" (click)="onChangeAdditionalTextSelect(text)">
          <span class="icon-add select-btn"></span>
          <span [innerHtml]="getHtmlContentForText(text)"></span>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #contentTemplatesModalTpl let-dialogRefSender="dialogRef">
  <div class="modal-header">
    <div class="modal-title">
      <h3>Content templates</h3>
      <button type="button" class="btn-close" (click)="dialogRefSender.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-content-templates-list (selectedChange)="onSelectedChange($event)" [selected]="contentTemplates"></app-content-templates-list>
  </div>
</ng-template>

<ng-template #telqIdModalTpl let-dialogRefSettingsTelqId="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Test ID Text Settings <span class="icon-help-1 text-neutral-n5"
          [tooltip]="'Test ID Text is a unique code automatically generated and added to the message body in order to match test results. <br><br>You can customize its format, case length and position in the text to mimic real traffic.'"
          tooltipPlacement="top"></span></h3>
      <button type="button" class="btn-close" (click)="dialogRefSettingsTelqId.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div [hidden]="!telqIdLoading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse small"></div>
    </div>
    <form [formGroup]="telqIdSettingsForm" class="mb-15">
      <div class="form-group mb-15">
        <span class="form-title d-inline-block mb-10">Type</span>
        <div class="form-check mb-0_7" *ngFor="let type of telqIdSettingsTypes">
          <input [value]="type.id" [(ngModel)]="telqIdSettingsModel.telqIdType" (change)="onChangeTelqIdSettingsType(type.id)" formControlName="telqIdType"
            class="form-check-input" type="radio" />
          <label class="form-check-label cp" (click)="onChangeTelqIdSettingsType(type.id)"> {{type.label}} </label>
        </div>
        <input-errors [control]="telqIdSettingsForm.controls.telqIdType" [service]="validationService"></input-errors>
      </div>
      <div [hidden]="!telqIdSettingsShowCase(telqIdSettingsModel.telqIdType)" class="form-group mb-15">
        <span class="form-title d-inline-block mb-10">
          Case
          <span class="icon-help-1 text-neutral-n6" [tooltip]="'Applicable for Alpha or Alphanumeric Test ID types. Select the desired case.'"
            tooltipPlacement="top"></span>
        </span>
        <div class="form-check mb-0_7" *ngFor="let case of telqIdSettingsCases">
          <input [value]="case.id" [(ngModel)]="telqIdSettingsModel.telqIdCase" formControlName="telqIdCase" class="form-check-input" type="radio" />
          <label class="form-check-label cp" (click)="telqIdSettingsModel.telqIdCase = case.id"> {{ case.label }} </label>
        </div>
        <input-errors [control]="telqIdSettingsForm.controls.telqIdCase" [service]="validationService"></input-errors>
      </div>
      <div [hidden]="!telqIdSettingsShowLength(telqIdSettingsModel.telqIdType)" class="form-group mb-10">
        <label class="form-label">
          Length
          <span class="icon-help-1 text-neutral-n6" [tooltip]="'Choose the length of your Test ID. Select a length between 4 and 20 characters.'"
            tooltipPlacement="top"></span>
        </label>
        <input [(ngModel)]="telqIdSettingsModel.telqIdLength" formControlName="telqIdLength" type="number" placeholder="Length" class="form-control" />
        <input-errors [control]="telqIdSettingsForm.controls.telqIdLength" [service]="validationService"></input-errors>
      </div>
    </form>
    <div class="alert alert-dark fw-medium text-break" role="alert" [tooltip]="'Simulated Test ID Text based on the selected settings.'">
      Simulated Test ID Text format: {{simulatedTestId}}
    </div>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button (click)="dialogRefSettingsTelqId.close(false)" class="btn btn-outline-dark">Cancel</button>
      <div>
        <a role="button" *ngIf="getTelqIdSettingsFormValid()" (click)="onSaveAsDefault()">Save as default</a>
        <button [disabled]="!getTelqIdSettingsFormValid()" (click)="onApplyTelqIdSettings()" class="btn btn-primary ms-15">
          Confirm
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #contentTemplateImportModalTpl let-dialogRefContentTemplate="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Import content templates from file</h3>
      <button type="button" class="btn-close" (click)="dialogRefContentTemplate.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-content-template-import [fileList]="importContentTemplateFileList" [parent]="'lnt-content-templates'"
      (import)="onImportContentTemplates($event)"></app-content-template-import>
  </div>
</ng-template>
